<template>
<li :class="tabmenuitemclass" role="tab" v-show="showelement">
  <a class="p-menuitem-link" role="presentation" @click="goToTab" >
    <template v-if="data.icon_type=='material'">
      <span class="material-symbols-outlined md-13">
      {{data.icon}}
      </span>
    </template>
    <template v-else>    
    <p :class="'p-menuitem-icon m-0 pi pi-fw pi-'+data.icon"></p>
    </template>
    <p class="p-menuitem-text m-0 mt-2 hide_on_mobile">{{$store.state.languages.lang_phrases[data.title]}}</p>
    <p class="p-ink"></p>
  </a>
</li>
</template>

<script>
export default {

  name: 'TabNavigationItem',
  props:["data"],
  data () {
    return {

    }
  },
  computed:{
    userroles()
    {
       let user = this.$store.state.auth.user
      let userroles = user.userroles.map((element)=>{return element.name})
      return userroles
    },
    is_supplier()
    {     
      if(this.userroles.includes("supplier"))
      {
        return true
      }
      return false
    },

    is_admin()
    {     
      if(this.userroles.includes("admin"))
      {
        return true
      }
      return false
    },
    is_brand()
    {     
      if(this.userroles.includes("brand"))
      {
        return true
      }
      return false
    },
    is_planner()
    {     
      if(this.userroles.includes("planner"))
      {
        return true
      }
      return false
    },
    is_auditor()
    {     
      if(this.userroles.includes("auditor"))
      {
        return true
      }
      return false
    },
    tabmenuitemclass()
    {
      
      if(this.$store.state.ui.activetab==this.data.title)
      {
        return " p-tabmenuitem p-highlight"
      }
      else
      {
        return " p-tabmenuitem "
      }
    },
    showelement()
    {
      if(this.data.show)
      {
        if(this.data.show=="show")
        {
          return true
        }
        else
        {
          return false
        }

      }
      else
      {
        return true
      }
      
    }
  },
  methods:{
  	async goToTab()
  	{
      //console.log(this.data)
      //return false
      if(this.data.title=="geri_don")
      {
        if(this.is_supplier)
        {
          let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
        await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
        }
        if(this.is_auditor)
        {
          this.$router.push({ name: this.data.route ,params: { id: this.data.param} })
        }
        if(this.is_admin || this.is_brand ||this.is_planner)
        {
          //this.$router.push({ name: this.data.route ,params: { id: this.data.param} })
          let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
          await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
        }
        
        //return false
      }

      else if(this.data.title=="listeye_geri_don")
      {
        
        let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
        await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      else
      {
        this.$store.dispatch('ui/setActiveTab',this.data.title) 
        this.$router.push({ path: this.data.route })
      }
  		
  	}
  }
};
</script>

<style lang="css" scoped>
</style>